import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getLastPath, isAuthenticated } from '../CookiesUtil';
import { useAppNavigation } from '../historyUtils';

import LoginEmailForm from './LoginEmailForm';
import SocialLogin from './SocialLogin';
import LoginPhoneForm from './LoginPhoneForm';

interface LoginProps {
  onLogin: (userData: { email: string; name: string }) => void;
 
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {

  const { lang } = useParams<{ lang: string }>();
  const [showEmail, setShowEmail] = useState(false);
  const [showPhone, setShowPhone] = useState(false);
  const navigate = useAppNavigation();

  const toggleEmailForm = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowEmail((prev) => !prev);
  };

  const togglePhoneForm = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowPhone((prev) => !prev);
  };

  if (isAuthenticated()) {
    console.log("isAuthenticated ", isAuthenticated());
    const redirectPath = getLastPath() ?? '/restaurant/boss';
    navigate(redirectPath);
  }

  return (
    <div className="min-h-screen w-full flex flex-col justify-start items-center text-center">
      <div className="w-[400px] flex flex-col p-5 px-15 rounded-lg shadow-[0_10px_50px_#555]">
        {!showEmail && !showPhone && (
          <>
            <h1 className="text-2xl font-medium mb-8 text-gray-600">
              Customers Login...
            </h1>
            <SocialLogin />
          </>
        )}

        {!showPhone && (
          <button
            type="button"
            onClick={toggleEmailForm}
            className="w-full py-2 px-4 rounded font-normal mb-4 text-white bg-blue-400 hover:bg-blue-500"
          >
            {showEmail ? 'Return' : 'Login With Email'}
          </button>
        )}

        {!showEmail && (
          <button
            type="button"
            onClick={togglePhoneForm}
            className="w-full py-2 px-4 rounded font-normal mb-4 text-white bg-green-500 hover:bg-green-600"
          >
            {showPhone ? 'Return' : 'Login With Phone'}
          </button>
        )}

        {showEmail ? <LoginEmailForm onLogin={onLogin} /> : null}
        {showPhone ? <LoginPhoneForm onLogin={onLogin} /> : null}

        <h6 className="mt-3 text-sm text-gray-600">
          New user? <Link to="/signup" className="text-blue-500">Sign up!</Link>
        </h6>

        <div className="alert alert-warning" role="alert">
          If regular login doesn&apos;t work, try our test endpoint: http://localhost:18520/test/login
        </div>
      </div>
    </div>
  );
};

export default Login;